export default `
   <div class="styles__CategoryList">
  <div class="column featured">
        <div class="group featured"><span>
        <h2 class="title">Featured</h2>
      </span>
      <ul>
        <li>
          <a href="/view/petite/" title="Women's Petite Clothing">
            <div class="item"><div class="item-label">Petite Shop</div></div>
          </a>
        </li>

        <li>
          <a href="/view/tall/" title="Women's Tall Clothing">
            <div class="item">
              <div class="item-label">Tall Shop</div>
            </div>
          </a>
        </li>
        <li>
          <a href="/view/plus-size/" title="Women's Plus Size Clothing">
            <div class="item">
              <div class="item-label">Plus Shop</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="group featured"><span>
        <h2 class="title">Activity</h2>
      </span>
      <ul>
            <li><a href="/view/women/pajamas/" title="Women's Sleepwear & Pajamas">
              <div class="item">
                <div class="item-label">Sleepwear</div>
              </div>
            </a></li>
            <li>
            <a href="/view/workout/" title="Women's Workout">
               <div class="item">
                  <div class="item-label">Workout</div>
               </div>
            </a>
         </li>
        <li><a href="/s/womens-hiking-collection?keyword=women%27s+hiking+collection&amp;cm_sp=topnav_w_activities_hiking">
            <div class="item">
              <div class="item-label">Hiking</div>
            </div>
          </a></li>
        <li><a href="/s/womens-travel-collection?keyword=women%27s+travel+collection&amp;cm_sp=topnav_w_activities_travel">
            <div class="item">
              <div class="item-label">Travel</div>
            </div>
          </a></li>
        <li><a href="/s/womens-fishing-and-field-collection?keyword=women%27s+fishing+and+field+collection&amp;cm_sp=topnav_w_activities_fishingfield">
            <div class="item">
              <div class="item-label">Fishing &amp; Field</div>
            </div>
          </a></li>
        <li><a href="/s/womens-training-collection?keyword=women%27s+training+collection&amp;cm_sp=topnav_w_activities_training">
            <div class="item">
              <div class="item-label">Training</div>
            </div>
          </a></li>
        <li><a href="/s/womens-mountain-sports-collection?keyword=women%27s+mountain+sports+collection&amp;cm_sp=topnav_w_activities_mountainsports">
            <div class="item">
              <div class="item-label">Mountain Sports</div>
            </div>
          </a></li>
      </ul>
    </div>
  </div>
  <div class="column">
    <div class="group"><a href="/view/women/jackets/" title="Women's Jackets">
        <h2 class="title">Jackets</h2>
      </a>
      <ul>
        <li><a href="/view/women/jackets/parkas/" title="Women's Parkas">
            <div class="item">
              <div class="item-label">Parkas</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20117-580025/womens-casual?cm_sp=topnav_w_jackets-vests_casual">
            <div class="item">
              <div class="item-label">Casual</div>
            </div>
          </a></li>
        <li><a href="/view/women/jackets/features-insulated/" title="Women's Insulated Jackets">
            <div class="item">
              <div class="item-label">Insulated</div>
            </div>
          </a></li>
        <li><a href="/view/women/jackets/type-soft-shell/" title="Women's Soft Shell Jackets">
            <div class="item">
              <div class="item-label">Soft Shells</div>
            </div>
          </a></li>
        <li><a href="/view/women/jackets/type-rain/" title="Women's Rain Jackets">
            <div class="item">
              <div class="item-label">Rainwear</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20117-580024/womens-3-in-1?cm_sp=topnav_w_jackets-vests_3in1">
            <div class="item">
              <div class="item-label">3-in-1</div>
            </div>
          </a></li>
        <li><a href="/view/women/vests/" title="Women's Vests">
            <div class="item">
              <div class="item-label">Vests</div>
            </div>
          </a></li>
          <li><a href="/view/women/blazers/" title="Women's Blazers">
            <div class="item">
              <div class="item-label">Blazers</div>
            </div>
          </a></li>
      </ul>
    </div>
    <div class="group">
        <h2 class="title">Bottoms</h2>

      <ul>
        <li><a href="/view/women/pants/" title="Women's Pants">
            <div class="item">
              <div class="item-label">Pants</div>
            </div>
          </a></li>
        <li><a href="/view/women/jeans/" title="Women's Jeans">
            <div class="item">
              <div class="item-label">Jeans</div>
            </div>
          </a></li>
        <li><a href="/view/women/pants/leggings/" title="Women's Tights">
            <div class="item">
              <div class="item-label">Tights</div>
            </div>
          </a></li>
        <li><a href="/view/women/pants/capris/" title="Women's Capris">
            <div class="item">
              <div class="item-label">Capris</div>
            </div>
          </a></li>
        <li><a href="/view/women/shorts/" title="Women's Shorts">
            <div class="item">
              <div class="item-label">Shorts</div>
            </div>
          </a></li>
        <li><a href="/view/women/skirts/" title="Women's Skirts">
            <div class="item">
              <div class="item-label">Skirts</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20123-580010/womens-baselayers?cm_sp=topnav_w_bottoms_baselayers">
            <div class="item">
              <div class="item-label">Baselayers</div>
            </div>
          </a></li>
      </ul>
    </div>
    <div class="group"><a href="/view/women/tops/" title="Women's Tops">
        <h2 class="title">Tops</h2>
      </a>
      <ul>
        <li><a href="/view/women/tops/cardigans/" title="Women's Cardigans">
            <div class="item">
              <div class="item-label">Cardigans</div>
            </div>
          </a></li>
        <li><a href="/view/women/tops/tees/" title="Women's Tees">
            <div class="item">
              <div class="item-label">T-Shirts</div>
            </div>
          </a></li>
        <li><a href="/view/women/tops/tank-tops/" title="Women's Tank Tops">
            <div class="item">
              <div class="item-label">Tank Tops</div>
            </div>
          </a></li>
        <li><a href="/view/women/tops/sweaters/" title="Women's Sweaters">
            <div class="item">
              <div class="item-label">Sweaters</div>
            </div>
          </a></li>
          <li><a href="/view/women/tops/sweatshirts/" title="Women's Sweatshirts">
            <div class="item">
              <div class="item-label">Sweatshirts</div>
            </div>
          </a></li>
        <li><a href="/view/women/tops/hoodies/" title="Women's Hoodies">
            <div class="item">
              <div class="item-label">Hoodies</div>
            </div>
          </a></li>
        <li><a href="/view/women/pajamas/" title="Women's Pajamas">
            <div class="item">
              <div class="item-label">Sleep</div>
            </div>
          </a></li>
        <li><a href="/view/women/dresses/" title="Dresses">
            <div class="item">
              <div class="item-label">Dresses</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20150-580029/womens-baselayers?cm_sp=topnav_w_tops_baselayers">
            <div class="item">
              <div class="item-label">Baselayers</div>
            </div>
          </a></li>
      </ul>
    </div>
    <div class="group"><a href="/view/women/jackets/material-fleece/" title="Women's Fleece">
        <h2 class="title">Fleece</h2>
      </a>
      <ul>
        <li><a href="/c/20094-140003-20121/womens-technical?cm_sp=topnav_w_fleece_technical">
            <div class="item">
              <div class="item-label">Technical</div>
            </div>
          </a></li>
        <li><a href="/c/20094-140003-580031/womens-casual?cm_sp=topnav_w_fleece_casual">
            <div class="item">
              <div class="item-label">Casual</div>
            </div>
          </a></li>
      </ul>
    </div>
    <div class="group"><a href="/view/women/shoes/" title="Women's Shoes"><h2 class="title">Footwear</h2></a>
      <ul>
        <li><a href="/view/women/shoes/boots/" title="Women's Boots"><div class="item"><div class="item-label">Boots</div></div></a></li>
        <li><a href="/view/women/shoes/flats/" title="Women's Flats"><div class="item"><div class="item-label">Flats</div></div></a></li>
        <li><a href="/view/women/shoes/flip-flops/" title="Women's Flip Flops"><div class="item"><div class="item-label">Flip Flops</div></div></a></li>
        <li><a href="/view/women/shoes/sandals/" title="Women's Sandals"><div class="item"><div class="item-label">Sandals</div></div></a></li>
        <li><a href="/view/women/shoes/slippers/" title="Women's Slippers"><div class="item"><div class="item-label">Slippers</div></div></a></li>
        <li><a href="/view/women/shoes/sneakers/" title="Women's Sneakers"><div class="item"><div class="item-label">Sneakers</div></div></a></li>
        <li><a href="/view/women/shoes/wedges/" title="Women's Wedges"><div class="item"><div class="item-label">Wedges</div></div></a></li>
      </ul>
    </div>
    <div class="group"><a href="/view/women/accessories/" title="Women's Accessories">
        <h2 class="title">Accessories</h2>
      </a>
      <ul>
        <li><a href="/view/women/accessories/belts/" title="Women's Belts"><div class="item"><div class="item-label">Belts</div></div></a></li>
        <li><a href="/view/women/accessories/gloves/" title="Women's Gloves"><div class="item"><div class="item-label">Gloves</div></div></a></li>
        <li><a href="/view/women/accessories/hats/" title="Women's Hats"><div class="item"><div class="item-label">Hats</div></div></a></li>
        <li><a href="/view/women/accessories/headbands/" title="Women's Headbands"><div class="item"><div class="item-label">Headbands</div></div></a></li>
        <li><a href="/view/women/accessories/scarves/" title="Women's Scarves"><div class="item"><div class="item-label">Scarves</div></div></a></li>
        <li><a href="/view/women/accessories/socks/" title="Women's Socks"><div class="item"><div class="item-label">Socks</div></div></a></li>
        <li><a href="/view/women/accessories/sunglasses/" title="Women's Sunglasses"><div class="item"><div class="item-label">Sunglasses</div></div></a></li>
      </ul>
    </div>
  </div>
</div>`